var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrownAlt1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.89592 6.90223C2.579 6.51886 1.96084 6.77423 2.00195 7.27154L3.727 16.0421C3.81451 17.1007 4.69242 17.915 5.74626 17.915H18.2537C19.3076 17.915 20.1855 17.1007 20.273 16.0421L21.998 7.27154C22.0392 6.77423 21.421 6.51886 21.1041 6.90223L18.0986 10.5378C17.6205 11.1162 16.707 10.992 16.398 10.3066L12.9223 2.59867C12.5624 1.80044 11.4376 1.80044 11.0777 2.59867L7.60203 10.3066C7.29298 10.992 6.37953 11.1162 5.9014 10.5378L2.89592 6.90223Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.79232 19.9907C4.2257 19.9907 3.76636 20.4405 3.76636 20.9954C3.76636 21.5504 4.2257 22.0002 4.79232 22.0002H19.2077C19.7743 22.0002 20.2337 21.5504 20.2337 20.9954C20.2337 20.4405 19.7743 19.9907 19.2077 19.9907H4.79232Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrownAlt1);
export default __webpack_public_path__ + "static/media/crown-alt-1.ef76b6fbbf1acf33a6ee328decd48293.svg";
export { ForwardRef as ReactComponent };